import React from 'react';
import userIcon from '../../../../../assets/icons/user-icon.svg';
import { useTranslation } from 'react-i18next';

export default function UserSection({ userName, userMail, userCompany, handleLogout, logoutText }) {

  const { t: trans } = useTranslation();

  return <section className='user-section'>
    <img src={userIcon} alt='user' />
    <section>
      <ul>
        <li><strong>{trans('common-action.user')} </strong><p>{userMail}</p></li>
        {/* <li><strong>{trans('common-action.company')} </strong><p>{userCompany}</p></li> */}
        <li className='link' onClick={handleLogout.bind(null, 'logout')}>{logoutText}</li>
      </ul>
    </section>
  </section>
}